module.exports = __webpack_public_path__ + "static/TALCodesignSession1-e3550141bb893bbee32d154a04034be2.jpg";